import { Component, input } from '@angular/core';
import {
  GcLoadingSpinnerComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

@Component({
  selector: 'app-duct-content',
  template: `
    @if (isLoading()) {
      <div class="text-align-center">
        <gc-loading-spinner class="margin-bottom-0" />
        <strong>{{ 'duct.loading' | translate }}</strong>
      </div>
    } @else {
      @if (ductsMissing()) {
        <div class="duct-missing">
          {{ 'duct.missing' | translate }}
        </div>
      } @else {
        <ng-content />
      }
    }
  `,
  styles: [
    `
      .text-align-center {
        text-align: center;
      }
      .duct-missing {
        font-size: 15px;
        font-style: italic;
        margin: 5px 0;
      }
      .margin-bottom-0 {
        margin-bottom: 0px;
      }
    `,
  ],
  imports: [GcLoadingSpinnerComponent, IpoTranslatePipe],
})
export class DuctContentComponent {
  ductsMissing = input(false);
  isLoading = input(false);
}
